<div class="table-main-container" *ngIf="graph && gaugeGraph">
    <div class="graphs-table-main-container">
        <div class="channel-graph-container">
            <div class="header-container">
                <div class="header-title">
                    <div class="slots-text">
                        {{
                            'graph.gauge.table.channels.slots'
                                | translate: { slots: gaugeGraph.channels?.length, max: maxChannelSlots }
                        }}
                    </div>
                    <div class="add-row-button" [class.disable]="!showAddNewChannel()" (click)="addChannelRow()">
                        {{ 'graph.gauge.table.button.add-row' | translate }}
                    </div>
                </div>
            </div>
            <div class="table-container">
                <app-gauge-graph-table-header style="width: 100%"></app-gauge-graph-table-header>
                <div class="table-content">
                    <div class="no-channel-text" *ngIf="gaugeGraph.channels?.length === 0">
                        {{ 'graph.no-channels.text.row' | translate }}
                    </div>
                    <ng-container *ngIf="gaugeGraph.channels">
                        <app-gauge-graph-table-row
                            *ngFor="let channel of gaugeGraph.channels; let i = index"
                            [rowIndex]="i"
                            [channel]="channel"
                            [vesselId]="graph.vesselId"
                            [optionsVisible]="selectedRowIndex === i"
                            (onOptionsToggled)="optionsToggled(i)"
                            (onDeleteRow)="deleteChannelRow(i)"></app-gauge-graph-table-row>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'graph.cancel.dialog.title'"
    [discardLabel]="'graph.cancel.dialog.discard'"
    [goBackLabel]="'graph.cancel.dialog.go-back'"
    [saveLabel]="'graph.cancel.dialog.save'"></app-confirmation-window>
